module.exports = __webpack_public_path__ + "static/media/01_d_photo.2733bfed.jpg";